/**
 * Returns a string pluralized appropriately based on a number value
 */
export function pluralize(singularLabel: string, value: number): string {
    if (value === 1) {
        return singularLabel
    }

    return `${singularLabel}s`
}
